@if (selectedVideo$ | async; as selectedVideo) {
  <kehe-phoenix-video-player-modal
    [selectedVideo]="selectedVideo"
    (modalEvent)="handleKeheModalEvents()"
  >
  </kehe-phoenix-video-player-modal>
}
